var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lang.vcc)?_c('div',{staticClass:"about_credit_card"},[_vm._v("\n  "+_vm._s(_vm.lang.vcc.SFS_LANG_ROW_8)),_c('br'),_vm._v("\n  "+_vm._s(_vm.lang.vcc.SFS_LANG_ROW_9)+"\n  "),_c('i',{staticClass:"bullet_right fa fa-chevron-right",staticStyle:{"color":"rgb(164, 170, 189)","float":"right","line-height":"10pt"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }